// Modul zur Anzeige des Standard-Pauschale
"use strict";

import module from "./module.js";
import "./tests.spec.js";

export default module;
